import React from 'react'
import { Link } from "react-router-dom";
const Career = () => {
  return (
    <div className="career-area pb-120">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="career-left">
          <div className="career-img">
            <div className="row align-items-center">
              <div className="col-md-6">
                <img
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high"
                  className="career-img-1"
                  src="assets/img/career/01.jpg"
                  alt=""
                />
              </div>
              <div className="col-md-6">
                <img
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high"
                  className="career-img-2"
                  src="assets/img/career/02.jpg"
                  alt=""
                />
                <img
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high"
                  className="career-img-3"
                  src="assets/img/career/03.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="career-right">
          <div className="site-heading mb-3">
            <span className="site-title-tagline">Career Tips</span>
            <h2 className="site-title">
              Quick Career Tips To Help You Land <span>The Best Job</span> That
              Suits Your Skills And Aspirations.
            </h2>
          </div>
          <p>
          Finding the right job requires skills, persistence, and the right strategy. Stay proactive, build strong connections, and use modern job-hunting tools to enhance your career prospects.
          </p>
          <div className="career-list">
            <ul>
              <li>
                <i className="far fa-check-circle" /> <b> Craft a Strong Resume:</b> Highlight key skills and achievements.
              </li>
              <li>
                <i className="far fa-check-circle" /> <b>Improve Communication:</b> Strong verbal and written skills boost your chances. 
              </li>
              <li>
                <i className="far fa-check-circle" /> <b>Stay Updated:</b> Follow industry trends and emerging skills.
              </li>
              <li>
                <i className="far fa-check-circle" /> <b>Showcase Work:</b> Maintain a strong portfolio for impact.
              </li>
              <li>
                <i className="far fa-check-circle" /> <b>Use Job Portals Smartly:</b> Optimize your profile for better job.
              </li>
            </ul>
          </div>
          <Link to="/jobs" className="theme-btn">
            Find Your Job
          </Link>
        </div>
      </div>
    </div>
  </div>
</div>
  )
}

export default Career
